module.exports = __webpack_public_path__ + "media/images/countrysquared/lr-b079b7b6c9cfec3f2bf83efa09a242c4.svg";